import { t } from '@lingui/macro'
import React, { useMemo } from 'react'
import { Col, Form, Button, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import Flag from '../../../../components/Flag'
import { Input } from '../../../../components/Form'
import Modal, { ModalRef, useModalActions } from '../../../../components/Overlays/Modal'
import { RegulationCategoryDataMinimal } from '../../../../data/remote/RegulationCategory'
import { RegulationFolderDataMinimal, useCreateRegulationFolder } from '../../../../data/remote/RegulationFolder'
import useCombinedRef from '../../../../scripts/useCombinedRef'

export type CreateFolderModalProps = {
  category: RegulationCategoryDataMinimal
  onSuccess?: (folder: RegulationFolderDataMinimal) => unknown
}

const CreateFolderModal = React.forwardRef<ModalRef, CreateFolderModalProps>(function CreateFolderModal(
  { category, onSuccess },
  ref
) {
  const modalActions = useModalActions()
  const modalRef = useCombinedRef(modalActions.ref, ref)

  const { register, watch, handleSubmit } = useForm<{
    title: {
      de: string
      en: string
    }
  }>({
    defaultValues: {
      title: {
        de: '',
        en: ''
      }
    }
  })

  const createFolder = useCreateRegulationFolder()
  const onSubmit = useMemo(
    () =>
      handleSubmit((data) => {
        if (!createFolder.running) {
          createFolder.run({ ...data, categoryId: category.id }, (response) => {
            // history.push(generatePath(data.code))
            modalActions.close()
            onSuccess?.(response)
          })
        }
      }),
    [category.id, createFolder, handleSubmit, modalActions, onSuccess]
  )

  const translationPlaceholder = watch('title.de') || '(optional)'

  return (
    <Modal ref={modalRef}>
      <Modal.Header closeButton>
        <Modal.Title>{t`Ordner hinzufügen`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit}>
          <Row>
            <Col xs={12}>
              <Input name="category" label={t`Kategorie`} value={category.localizedTitle} readOnly />
            </Col>
            <Col xs={12}>
              <Input
                label={t`Name des Ordners`}
                {...register('title.de', { required: true })}
                prepend={<Flag language="de" />}
              />
              <Input
                label={t`Name des Ordners`}
                labelSrOnly
                {...register('title.en')}
                placeholder={translationPlaceholder}
                prepend={<Flag language="en" />}
              />
            </Col>
            <Col xs={6} className="ml-auto">
              <div className="d-grid mt-3">
                <Button variant="primary" type="submit" disabled={false} size="lg">
                  {t`Ordner hinzufügen`}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  )
})

export default CreateFolderModal
